import { CommonModule, DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { EvaluationService } from 'src/app/shared/services/evaluationservice/evaluation.service';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-evaluation-yearly',
  templateUrl: './evaluation-yearly.component.html',
  styleUrls: ['./evaluation-yearly.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent, RouterModule],
  providers: [DatePipe],
})
export class EvaluationYearlyComponent implements OnInit {

  public showSpinner = true;
  evaluations: any[] = [];
  date = new Date();
  model: any = {};
  user: any;
  userInfo: any;
  colormode: any;
  selectedMode: any;
  datamode: any;
  department: any;
  user_id: any;
  first_name: any;
  last_name: any;
  evaluate: any[] = [];
  searchText: any;
  searchDesignation: any;
  myDepartment: any;
  currentUser_role: any;
  constructor(private router: Router,
    private evaluationService: EvaluationService,
    public dashboardService: DashboardService,
    private sharedmode: SharedModeService,
    private datePipe: DatePipe) {
    this.model = {
      month_int: this.date.getMonth() + 1,
      month_char: this.datePipe.transform(this.date.setMonth(this.date.getMonth()), "MMMM"),
      month_year: this.date.getFullYear(),
    }
    this.user = JSON.parse(localStorage.getItem('user') || '');
    this.department = this.user.department
    if (this.department == 'Team Leads') {
      this.department = this.user.sub_department
    }
    const user_role = JSON.parse(this.user.user_role.user_roles)
    if (user_role.role_type == "Empolyee") {
      this.router.navigate(['/dashboard-1']);
    } else if (user_role.role_type == "Admin") {
      this.router.navigate(['/new-admin-dashboard']);
    }
    this.currentUser_role = user_role.role_type

    this.user_detail();

  }

  ngOnInit(): void {
    this.getAllEvaluationByAdmin(this.department);
    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
    });
  }
  toggleMode(mode: string) {
    this.datamode
    this.sharedmode.setMode(mode);
  }
  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
      this.showSpinner = false;
    })

  }
  onReset(form: NgForm) {
    form.reset();

    this.getAllEvaluationByAdmin(this.department);
  }

  onSubmit(form: NgForm) {
    this.myDepartment = this.user.sub_department;
    // this.myDepartment = 'Web Application Development';
    const formData = form.value;
    const date = new Date(formData.date);
    this.model = {
      month_int: date.getMonth() + 1,
      month_char: this.datePipe.transform(date, "MMMM"),
      month_year: date.getFullYear(),
      department: this.myDepartment,

    };

    this.getAllEvaluationByAdmin(this.model);
  }

  addEvaluation(data: any) {
    this.user_id = data.id
    this.first_name = data.first_name
    this.last_name = data.last_name
    this.router.navigate(['/user-evaluation'], {
      queryParams: {
        data: JSON.stringify(data),
        id: JSON.stringify(this.user_id),
        first_name: this.first_name,
        last_name: this.last_name
      },
      skipLocationChange: true,
    });
  }



  filterEvaluationsByName() {
    this.searchDesignation = '';
    if (this.searchText !== '' && this.searchText !== undefined && this.searchText !== null) {

      this.evaluate = this.evaluations.filter(data =>
        data.first_name.toLowerCase().includes(this.searchText.toLowerCase())
        ||
        data.last_name.toLowerCase().includes(this.searchText.toLowerCase())
      );
    }
    else {
      this.evaluate = this.evaluations;
    }
  }
  filterEvaluationsByDesignation() {
    this.searchText = '';
    if (this.searchDesignation !== '' && this.searchDesignation !== undefined && this.searchDesignation !== null) {

      this.evaluate = this.evaluations.filter(data =>
        data.description.toLowerCase().includes(this.searchDesignation.toLowerCase())
      );
    }
    else {
      this.evaluate = this.evaluations;
    }
  }

  filterPMpending(): void {
    this.evaluate = this.evaluations;
    const evaluationsWithP = this.evaluate.filter(item => item.employee_evaluation_current_month === null || item.employee_evaluation_current_month.pm_points === '0');
    this.evaluate = evaluationsWithP;
  }
  filterPMAdd(): void {
    this.evaluate = this.evaluations;
    const evaluationsWithPoints = this.evaluate.filter(item => item.employee_evaluation_current_month !== null && item.employee_evaluation_current_month.pm_points > '0' && item.employee_evaluation_current_month.is_evaluation === '0');
    this.evaluate = evaluationsWithPoints;
  }
  filterPMpublished(): void {
    this.evaluate = this.evaluations;
    const evaluationsWithPoints = this.evaluate.filter(item => item.employee_evaluation_current_month !== null && item.employee_evaluation_current_month.is_evaluation === '1');
    this.evaluate = evaluationsWithPoints;
  }
  filterTLpending(): void {
    this.evaluate = this.evaluations;
    const evaluationsWithP = this.evaluate.filter(item => item.employee_evaluation_current_month === null || item.employee_evaluation_current_month.points === '0');
    this.evaluate = evaluationsWithP;
  }
  filterTLPublish(): void {
    this.evaluate = this.evaluations;
    const evaluationsWithPoints = this.evaluate.filter(item => item.employee_evaluation_current_month !== null && item.employee_evaluation_current_month.points > '0');
    this.evaluate = evaluationsWithPoints;
  }
  filterReset(): void {
    this.searchText = '';
    this.searchDesignation = '';
    this.evaluate = this.evaluations;

  }
  selectedOption = '';
  callFunction() {
    switch (this.selectedOption) {
      case 'TLpending':
        this.filterTLpending();
        break;
      case 'TLPublish':
        this.filterTLPublish();
        break;
      case 'PMpending':
        this.filterPMpending();
        break;
      case 'PMadd':
        this.filterPMAdd();
        break;
      case 'PMpublished':
        this.filterPMpublished();
        break;
      case 'filterReset':
        this.filterReset();
        this.selectedOption = '';

        break;
      default:
        break;
    }
  }


  getAllEvaluationByAdmin(department: any) {
    this.showSpinner = true


    this.evaluationService.getAllUsersEvaluationteam(department).then((value) => {
      if (value.success) {
        this.showSpinner = false

        this.evaluations = value.data;
        this.evaluate = this.evaluations;
        this.evaluations.forEach((data: any) => {
          if (data.employee_evaluation_search != null) {
            data.percentage = data.employee_evaluation_search.points + "/10";
            const bandPercentage = (data.employee_evaluation_search.points / 10) * 100;
            data.bands = bandPercentage <= 25 ? 1 : bandPercentage > 25 && bandPercentage <= 50 ? 2
              : bandPercentage > 50 && bandPercentage <= 75 ? 3 : 4
          }
        });
      }
      else {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    });
  }
  navigateToAllUsersEvaluation() {
    this.router.navigate(['/all-users-evaluation']);
  }

}
